/*
    @file:
        app.js

    @description: 
        Core Javascript file that handles most
        of the stuff that happens on the site   
*/

import '../sass/main.scss';

// Variables
var $                   = require( 'jquery' );
var jQuery              = require( 'jquery' );
global.jQuery           = require('jquery');

var fullpagejs          = require('./modules/fullpage');
var carousels           = require('./modules/carousels');
var clickEvents         = require('./modules/clickEvents');
var AOS                 = require('aos');
var midnight            = require('./vendor/midnight');
var quantity            = require('./modules/quantity');

// Events
$(document).ready(function () {
    navigator.sayswho= (function(){
        var ua= navigator.userAgent, tem,
            M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    })();

    $('body').addClass(navigator.sayswho);

    $('header').midnight({
        headerClass: 'header-container',
        innerClass: 'header-inner',
        defaultClass: 'default'
    });

    AOS.init({
        disable: 'mobile',
        initClassName: 'aos-init',
        animatedClassName: 'aos-animate',
        debounceDelay: 50,
        throttleDelay: 99,
        offset: 150,
    });

    var progress = $('svg .progress');
    var coverHeight = $('.cover-news').outerHeight(true);
    var docHeight = $('.page-news-single').outerHeight(true);
    window.addEventListener('scroll', setScrollPerc);

    function setScrollPerc() {
        var top = $(document).scrollTop();
        var perc = Math.ceil(top*100/(docHeight + coverHeight + 264));
        progress.css('strokeDashoffset', (264 - (perc/150*264)));
    }

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 50) {
            $(".header-wrapper.alter").addClass("color-invert");
        } else {
            $(".header-wrapper.alter").removeClass("color-invert");
        }
    });

    if($('.text-container table').length > 0) {
        $('.text-container table').each(function() {
           $(this).wrapAll('<div class="table-overflow"></div>');
        });
    }

    function moveProductTitle() {
        if($('.cover-shop--single').length && $(window).innerWidth() < 768) {
            $('.cover-shop--single .content .top').prependTo('.cover-shop--single .gallery');
        } else if($('.cover-shop--single .gallery .top').length && $(window).innerWidth() >= 768) {
            $('.cover-shop--single .gallery .top').prependTo('.cover-shop--single .content');
        }
    }

    moveProductTitle();

    $(window).on('resize', function() {
       moveProductTitle();
    });
});
